import React, { useState } from "react";
import "../../assets/css/tms-layout/tms-layout.scss";
// import TmsImageUpload from "../../components/tms-customs/tms-image-upload";
const TmsWelcome = () => {
  const [templeDetails] = useState(
    JSON.parse(localStorage.getItem("templeDetails"))
  );
  return (
    <div className="tms-welcome">
      <div>
        <h2>Vrishti Technologies</h2>
        <h4>{templeDetails?.name}</h4>
      </div>
    </div>
  );
};
export default TmsWelcome;
